import { render, staticRenderFns } from "./PercentGroup.vue?vue&type=template&id=5c2957a5&scoped=true&"
import script from "./PercentGroup.vue?vue&type=script&lang=js&"
export * from "./PercentGroup.vue?vue&type=script&lang=js&"
import style0 from "./PercentGroup.vue?vue&type=style&index=0&id=5c2957a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2957a5",
  null
  
)

export default component.exports